import { render } from "./dispatch-email.vue?vue&type=template&id=713d100f&scoped=true"
import script from "./dispatch-email.vue?vue&type=script&lang=js"
export * from "./dispatch-email.vue?vue&type=script&lang=js"

import "./dispatch-email.vue?vue&type=style&index=0&id=713d100f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713d100f"]])

export default __exports__